import { GRID_CELL_SIZE, OzGrid, OzGridCell, OzGridRow } from '@omaze/omaze-ui';
import React, { ReactElement } from 'react';

import { LinkSection } from './LinkSection';
import { IShopifyFooterSection } from './shopifyFooterSections';
import { useFetchFooterLinks } from './use-fetch-footer-links/useFetchFooterLinks';

export function LinkSections (): ReactElement {
    const [prizesSection, aboutSection, supportSection]: IShopifyFooterSection[] = useFetchFooterLinks();

    return (
        <OzGrid>
            <OzGridRow className="justify-between">
                <OzGridCell smSize={GRID_CELL_SIZE.COLUMN_4} mdSize={GRID_CELL_SIZE.COLUMN_2} lgSize={GRID_CELL_SIZE.COLUMN_2}>
                    <LinkSection section={prizesSection} />
                </OzGridCell>
                <OzGridCell smSize={GRID_CELL_SIZE.COLUMN_4} mdSize={GRID_CELL_SIZE.COLUMN_2} lgSize={GRID_CELL_SIZE.COLUMN_2}>
                    <LinkSection section={aboutSection} />
                </OzGridCell>
                <OzGridCell className="md:mt-0" smSize={GRID_CELL_SIZE.COLUMN_4} mdSize={GRID_CELL_SIZE.COLUMN_3} lgSize={GRID_CELL_SIZE.COLUMN_2}>
                    <LinkSection section={supportSection} />
                </OzGridCell>
            </OzGridRow>
        </OzGrid>
    );
}
